// platform.js — where the app is running, for copy that only makes sense in
// one place (2026-11-02). Pure, no Capacitor import: callers pass the facts.

const MOBILE_UA = /iPhone|iPad|iPod|Android|Mobile/i;

/** A phone or tablet browser: not the native app, and a mobile user agent (or an iPad reporting itself as a Mac with touch). */
export function isMobileWebBrowser({ native = false, userAgent = '', maxTouchPoints = 0 } = {}) {
  if (native) return false;
  const ua = String(userAgent || '');
  if (MOBILE_UA.test(ua)) return true;
  // iPadOS Safari presents a desktop Macintosh user agent; touch points give it away.
  return /Macintosh/i.test(ua) && Number(maxTouchPoints) > 1;
}

/**
 * The App Store install pitch belongs only on a mobile web browser: never
 * inside the native app (it would advertise the app the user is standing in),
 * and not on a desktop browser, where the web app is the product.
 */
export function showAppStorePrompt(facts) {
  return isMobileWebBrowser(facts);
}
